import * as React from 'react';
import classnames from 'classnames';
import Flex, { Props as FlexProps } from '../Flex/Flex';
import './AppLayout.css';

export interface Props extends FlexProps {
  isInResponsiveView?: boolean;
  isSidebarVisible?: boolean;
}

const AppLayout: React.FunctionComponent<Props> = (props: Props) => {
  const { isInResponsiveView, isSidebarVisible, ...rest } = props;
  const classes = classnames('AppLayout', {
    'AppLayout--responsive-view': isInResponsiveView,
    'AppLayout--sidebar-visible': isSidebarVisible,
  });

  return (
    <Flex { ...rest } className={ classes } direction="vertical" grow />
  );
};

export default AppLayout;
